// Tiny DOM builder for the tutorial controllers: createElement + textContent only, never innerHTML.
// h("button", { class: "x", type: "button", "data-action": "a#b" }, "Label", childNode)
// A null/false attribute value is skipped; `true` sets an empty attribute (disabled, hidden).

export function h(tag, attrs = {}, ...children) {
  const el = document.createElement(tag)
  for (const [name, value] of Object.entries(attrs || {})) {
    if (value == null || value === false) continue
    if (name === "class") el.className = value
    else if (name === "value") el.value = value
    else el.setAttribute(name, value === true ? "" : String(value))
  }
  for (const child of children.flat()) {
    if (child == null || child === false) continue
    el.append(child instanceof Node ? child : document.createTextNode(String(child)))
  }
  return el
}
